var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"followUpPage"},[_c('v-app',{attrs:{"id":"vApp"}},[_c('FollowUpOverlay',{attrs:{"overlay-type":_vm.overlayType,"parent-view":'Followup',"id":"followUpOverlay"},on:{"overlay-off":_vm.overlayOff}}),_c('VueFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }